import { render } from "./Bizum.vue?vue&type=template&id=48b7551b&scoped=true"
import script from "./Bizum.vue?vue&type=script&lang=js"
export * from "./Bizum.vue?vue&type=script&lang=js"

import "./Bizum.vue?vue&type=style&index=0&id=48b7551b&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b7551b"]])

export default __exports__